/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { debounce } from 'lodash';
import { TextField } from '@mui/material';

// COMPONENT
function DebouncedTextInput({ onChange, initialValue, ...rest }) {
  const [searchQuery, setSearchQuery] = useState(initialValue ?? '');

  const debounceOnChange = React.useCallback(debounce(onChange, 350), [onChange]);

  return (
    <TextField
      variant="standard"
      value={searchQuery}
      onChange={(evt) => {
        setSearchQuery(evt.target.value);
        debounceOnChange(evt.target.value);
      }}
      {...rest}
    />
  );
}

export default DebouncedTextInput;
